export default "__VITE_ASSET__seKIal1D__"